// ===========================================
// utils/formatters.js
// ===========================================
export const formatFileSize = (bytes) => {
  if (!bytes) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
};

export const formatDate = (dateString) => {
  // Parse the date string and convert to local timezone
  let date = new Date(dateString);
  
  // If the date string doesn't include timezone info, assume it's UTC
  if (!dateString.includes('T') || (!dateString.includes('Z') && !dateString.includes('+'))) {
    // Treat as UTC and convert to local time
    const utcTime = new Date(dateString + (dateString.includes('T') ? '' : 'T00:00:00') + 'Z');
    date = new Date(utcTime.getTime());
  }
  
  const now = new Date();
  
  // Get the time difference in milliseconds
  const timeDiff = now.getTime() - date.getTime();
  
  // Handle negative time differences (future dates)
  if (timeDiff < 0) {
    return 'Just now';
  }
  
  const minutesDiff = Math.floor(timeDiff / (1000 * 60));
  const hoursDiff = Math.floor(timeDiff / (1000 * 60 * 60));
  const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  
  // Standard post date format - for uploads within the last 5 minutes, show "Just now"
  if (minutesDiff < 5) return 'Just now';
  if (minutesDiff < 60) return `${minutesDiff}m ago`;
  if (hoursDiff < 24) return `${hoursDiff}h ago`;
  if (daysDiff < 7) return `${daysDiff}d ago`;
  if (daysDiff < 30) return `${Math.floor(daysDiff / 7)}w ago`;
  if (daysDiff < 365) return `${Math.floor(daysDiff / 30)}mo ago`;
  
  // For older posts, show the actual date
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined
  });
};

export const openSafely = (url) => {
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};